/**
 * Displays an input field if type submit
 */
import React from 'react';
import PropTypes from 'prop-types';
import MODES from '../onSubmitModes';

export default class SubmitButton extends React.Component {
    static propTypes = {
        mode: PropTypes.string,
        value: PropTypes.string,
        className: PropTypes.string,
        onClick: PropTypes.func,
        type: PropTypes.string,
    };

    static defaultProps = {
        onClick: null,
        type: 'submit',
    };

    render() {
        const className =
            this.props.mode === MODES.SAVING ? 'button--in-progress' : '';

        const disabled =
            this.props.mode === MODES.SAVING ||
            this.props.mode === MODES.DISABLED;

        return (
            <button
                className={`button ${className} ${this.props.className}`}
                disabled={disabled}
                onClick={this.props.onClick}
                type={this.props.type}
            >
                {this.props.value}
            </button>
        );
    }
}
